import { BareGoodsEntity } from '../reducers/goodsToOrderFormReducer';

export const filterUniqueBareGoodsByArticle = (bareGoods: BareGoodsEntity[]) => {
    const uniqueArticlesGoods = bareGoods.filter(
        (value, index, array) => array.findIndex((g) => g.article?.id === value.article?.id) === index,
    );

    return uniqueArticlesGoods.map((ua) => {
        const filteredGoods = bareGoods.filter((bg) => bg.article?.id === ua.article?.id);

        const newBareGood: BareGoodsEntity = {
            availableQuantity: filteredGoods[0].availableQuantity,
            index: filteredGoods[0].index,
            article: filteredGoods[0].article,
            goods: filteredGoods[0].goods,
            orderedQuantity: filteredGoods.reduce((acc, val) => {
                return (acc += val.orderedQuantity);
            }, 0),
        };

        return newBareGood;
    });
};
